import { render } from "./HistDailyIA.vue?vue&type=template&id=2341b39a&scoped=true"
import script from "./HistDailyIA.vue?vue&type=script&lang=js"
export * from "./HistDailyIA.vue?vue&type=script&lang=js"

import "./HistDailyIA.vue?vue&type=style&index=0&id=2341b39a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2341b39a"]])

export default __exports__